import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../contexts/AuthContext';
import ProtectedRoute from '../components/ProtectedRoute';
import AppLayout from '../components/AppLayout';
import Home from '../pages/Home';
import Login from '../pages/Login';
import Register from '../pages/Register';
import Dashboard from '../pages/Dashboard';
import DocumentsList from '../pages/DocumentsList';
import DocumentDetail from '../pages/DocumentDetail';
import AddDocument from '../pages/AddDocument';
import EditDocument from '../pages/EditDocument';
import Settings from '../pages/Settings';
import AdminDashboard from '../pages/AdminDashboard';
import PendingUsers from '../pages/PendingUsers';
import CommissionManagement from '../pages/CommissionManagement';
import MembersList from '../pages/MembersList';

const AppRouter = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Routes protégées avec layout mobile */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/documents" element={<DocumentsList />} />
                    <Route path="/documents/:id" element={<DocumentDetail />} />
                    <Route path="/documents/add" element={<AddDocument />} />
                    <Route path="/documents/edit/:id" element={<EditDocument />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/parametres" element={<Settings />} />

                    {/* Routes Admin */}
                    <Route path="/admin" element={<AdminDashboard />} />
                    <Route path="/admin/pending-users" element={<PendingUsers />} />
                    <Route path="/admin/commissions" element={<CommissionManagement />} />
                    <Route path="/admin/members" element={<MembersList />} />

                    {/* Route par défaut */}
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </AppLayout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default AppRouter;
